/**
 * The last thing that went wrong in this browser, kept so "Report a problem"
 * can send it along: the person rarely knows what an error says, and the
 * operator should not have to ask. Memory only — nothing is stored or sent
 * until the person chooses to report.
 */
export const APP_VERSION = process.env.REACT_APP_VERSION || "dev";

let last = null;

const describe = (error) => {
  if (!error) return null;
  if (typeof error === "string") return error;
  return [error.name, error.message].filter(Boolean).join(": ") + (error.stack ? `\n${String(error.stack).split("\n").slice(1, 6).join("\n")}` : "");
};

export const recordError = (error, where = "") => {
  const text = describe(error);
  if (!text) return;
  last = `${where ? `[${where}] ` : ""}${text}`.slice(0, 3000);
};

export const lastError = () => last;

/** Called once at start-up. */
export const installErrorCapture = () => {
  window.addEventListener("error", (event) => recordError(event.error || event.message, "error"));
  window.addEventListener("unhandledrejection", (event) => recordError(event.reason, "promise"));
};
